import gql from "graphql-tag";

export const GET_MY_USER = gql`
  {
    myProfile {
      name
      sub
      phone_number
      stripeCustomerId
      isProUser
      isCustomer
    }
  }
`;

export const GET_MY_IDENTITY = gql`
  {
    myIdentity
  }
`;

export const ADMIN_PUT_USER = gql`
  mutation AdminPutUser($input: AdminUserInput) {
    adminPutUser(input: $input) {
      sub
    }
  }
`;

export const ADMIN_CHANGE_USER_EMAIL = gql`
  mutation AdminChangeUserEmail($userId: ID!, $newEmailAddress: String!) {
    adminChangeUserEmail(userId: $userId, newEmailAddress: $newEmailAddress) {
      sub
    }
  }
`;

export const ADMIN_PUT_STUDENT = gql`
  mutation AdminPutStudent($input: AdminStudentInput) {
    adminPutStudent(input: $input) {
      id
    }
  }
`;

export const ADMIN_DELETE_USER = gql`
  mutation AdminDeleteUser($id: ID!) {
    adminDeleteUser(id: $id) {
      sub
    }
  }
`;

export const ADMIN_GET_STUDENT = gql`
  query getStudent($id: ID!) {
    getStudent(id: $id) {
      id
      name
      archived
      reportFrequency
      profileImageUrl
      myTeacher {
        sub
        email
        name
      }
      archived
      parents {
        sub
        email
        name
      }
    }
  }
`;

export const ADMIN_GET_SUBSCRIPTION = gql`
  query getSubscription($id: ID!) {
    subscription(id: $id) {
      id
      customer
      quantity
      users {
        sub
        email
        name
      }
      status
    }
  }
`;

export const ADMIN_CREATE_SUBSCRIPTION = gql`
  mutation AdminCreateSubscription($input: AdminCreateSubscriptionInput) {
    adminCreateSubscription(input: $input) {
      id
    }
  }
`;

export const ADMIN_TRANSFER_STUDENTS = gql`
  mutation AdminTransferStudents($currentUser: ID!, $newUser: ID!) {
    adminTransferStudents(currentUser: $currentUser, newUser: $newUser) {
      sub
    }
  }
`;

export const LIST_STUDENTS = gql`
  {
    myStudents {
      id
      name
      reportFrequency
      archived
    }
  }
`;

export const LIST_PARENT_STUDENTS = gql`
  {
    myProfile {
      sub
      children {
        id
        name
        archived
        myTeacher {
          sub
          name
        }
        reportFrequency
        unreadCount
      }
    }
  }
`;

export const GET_USER = gql`
  query getUser($id: ID!) {
    user(id: $id) {
      email
      name
      phone_number
      sub
      cognitoUser {
        status
        name
        phone_number
        createDate
        lastModifiedDate
      }
      group
      groups
      status
      teachers {
        sub
        name
        email
      }
      children {
        id
        name
      }
      students {
        id
        name
        archived
      }
      assistants {
        sub
        name
        email
      }
      subscription_id
      stripeCustomerId
      isProUser
    }
  }
`;

export const FIND_USERS = gql`
  query getUsers($filter: String) {
    users(filter: $filter) {
      email
      name
      sub
      status
    }
  }
`;

export const GET_NEW_STUDENT = gql`
  query newStudent {
    newStudent {
      id
      name
      reportFrequency
      profileImageUrl
      parents {
        email
        sub
      }
      teacher
      fields
    }
  }
`;

export const GET_STUDENT = gql`
  query getStudent(
    $id: ID!
    $startDate: AWSDate
    $endDate: AWSDate
    $ascending: Boolean
    $nextToken: String
  ) {
    getStudent(id: $id) {
      id
      name
      reportFrequency
      profileImageUrl
      teacher
      archived
      parents {
        sub
      }
      pagedReports(
        startDate: $startDate
        endDate: $endDate
        ascending: $ascending
        nextToken: $nextToken
      ) {
        reports {
          id
          sent
          read
          reportType
          files {
            key
          }
          date
          unreadCount
        }
        nextToken
      }
    }
  }
`;

export const GET_EDIT_STUDENT = gql`
  query getStudent($id: ID!) {
    getStudent(id: $id) {
      id
      name
      reportFrequency
      profileImageUrl
      archived
      parents {
        name
        email
        sub
        status
      }
      teacher
      allFields {
        id
        label
      }
      fieldIds
      pagedReports {
        reports {
          id
          sent
          read
          reportType
          date
          unreadCount
        }
        nextToken
      }
    }
  }
`;

export const GET_PROFILE = gql`
  query getProfile {
    myProfile {
      sub
      assistants {
        name
        email
        sub
        status
      }
    }
  }
`;

export const GET_ASSISTANT_PROFILE = gql`
  query getProfile {
    myProfile {
      sub
      teachers {
        sub
        name
        email
        students {
          id
          name
          reportFrequency
          archived
        }
      }
    }
  }
`;

export const GET_FIELDS = gql`
  query MyFields {
    myFields {
      id
      control
      label
      options {
        text
        value
        key
      }
      value
    }
  }
`;

export const GET_STUDENT_FIELDS = gql`
  query GetStudentFields($studentId: ID!) {
    getStudent(id: $studentId) {
      id
      name
      reportFrequency
      archived
      myTeacher {
        sub
        isProUser
      }
      fields {
        control
        options {
          text
          value
          key
        }
        label
        value
      }
    }
  }
`;

export const GET_STUDENT_REPORT_ACTIVITY = gql`
  query getReport($studentId: ID!, $reportId: ID!, $accessReason: String) {
    getStudent(id: $studentId) {
      id
      report(id: $reportId, reason: $accessReason) {
        id
        log {
          name
          date
          action
          description
        }
      }
    }
  }
`;

export const GET_STUDENT_REPORT = gql`
  query getReport(
    $studentId: ID!
    $reportId: ID!
    $accessReason: String
    $language: String
  ) {
    getStudent(id: $studentId) {
      id
      name
      archived
      reportFrequency
      myTeacher {
        sub
        isProUser
      }
      report(id: $reportId, reason: $accessReason, lang: $language) {
        id
        date
        sent
        reportType
        student
        lastReadDate
        comments {
          commentUser {
            sub
            name
          }
          date
          text
        }
        files {
          key
          name
          url
          contentType
        }
        fields {
          control
          options {
            text
            value
            key
          }
          label
          value
        }
      }
    }
  }
`;

export const GET_STUDENT_REPORT_RANGE = gql`
  query getStudentReports(
    $studentId: ID!
    $startDate: AWSDate
    $endDate: AWSDate
    $ascending: Boolean
    $nextToken: String
  ) {
    getStudent(id: $studentId) {
      id
      name
      reports(
        startDate: $startDate
        endDate: $endDate
        ascending: $ascending
        nextToken: $nextToken
      ) {
        reports {
          id
          date
          sent
          reportType
          student
          lastReadDate
          comments {
            commentUser {
              sub
              name
            }
            date
            text
          }
          files {
            key
            name
            url
            contentType
          }
          fields {
            control
            options {
              text
              value
              key
            }
            label
            value
          }
        }
        nextToken
      }
    }
  }
`;

export const UPDATE_STUDENT_REPORT = gql`
  mutation EditStudentReport($input: ReportInput!) {
    editReport(input: $input) {
      id
      date
      sent
      reportType
      student
      fields {
        control
        options {
          text
          value
          key
        }
        label
        value
      }
      files {
        key
        name
        url
        contentType
      }
    }
  }
`;

export const DELETE_STUDENT = gql`
  mutation DeleteStudent($id: ID!) {
    deleteStudent(id: $id) {
      id
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($email: String, $password: String) {
    resetPassword(email: $email, password: $password) {
      sub
    }
  }
`;

export const UPDATE_STUDENT = gql`
  mutation EditStudent($id: ID!, $input: StudentInput!) {
    editStudent(id: $id, input: $input) {
      id
      name
      archived
      fieldIds
      reportFrequency
      profileImageUrl
    }
  }
`;

export const ADD_STUDENT = gql`
  mutation AddStudent($id: ID!, $input: StudentInput!) {
    addStudent(id: $id, input: $input) {
      id
      name
      archived
      fieldIds
      reportFrequency
      profileImageUrl
    }
  }
`;

export const SEND_STUDENT_REPORT = gql`
  mutation SendReport($student: ID!, $report: ID!) {
    sendReport(student: $student, report: $report)
  }
`;

export const MARK_REPORT_AS_READ = gql`
  mutation MarkReportAsRead($report: ID!) {
    markReportAsRead(report: $report) {
      id
      read
    }
  }
`;

export const DELETE_STUDENT_REPORT = gql`
  mutation DeleteReport($id: ID!) {
    deleteReport(id: $id) {
      id
    }
  }
`;

export const EDIT_FIELD = gql`
  mutation EditField($field: FieldInput!) {
    editField(input: $field) {
      id
      control
      label
      options {
        text
        value
        key
      }
      value
    }
  }
`;

export const DELETE_FIELD = gql`
  mutation DeleteField($id: ID!) {
    deleteField(id: $id) {
      id
    }
  }
`;

export const RESEND_INVITATION = gql`
  mutation ResendInvitation($user: ID!) {
    resendUserInvitation(user: $user) {
      email
      sub
      status
    }
  }
`;

export const INVITE_USER = gql`
  mutation InviteUser(
    $email: String
    $group: String
    $id: ID
    $subscription: String
  ) {
    inviteUser(
      email: $email
      group: $group
      id: $id
      subscription: $subscription
    ) {
      email
      sub
      status
    }
  }
`;

export const REMOVE_PARENT = gql`
  mutation RemoveParent($student: ID!, $index: Int) {
    removeParent(student: $student, index: $index) {
      sub
    }
  }
`;

export const REMOVE_ASSISTANT = gql`
  mutation RemoveAssistant($assistant: ID!) {
    removeAssistant(assistant: $assistant) {
      sub
    }
  }
`;

export const UPDATE_USER_ATTRIBUTES = gql`
  mutation UpdateUserAttributes($input: UserInput) {
    editMyUser(input: $input) {
      sub
      name
      phone_number
    }
  }
`;

export const ADD_ASSISTANT = gql`
  mutation AddAssistant($email: String) {
    addAssistant(email: $email) {
      email
      status
      sub
    }
  }
`;

export const ADD_REPORT_COMMENT = gql`
  mutation AddReportComment($student: ID!, $report: ID!, $comment: String) {
    addReportComment(student: $student, report: $report, comment: $comment) {
      user
      report
      student
      commentUser {
        sub
        name
      }
      text
      date
    }
  }
`;

export const ON_REPORT_EDITED = gql`
  subscription ReportEdited($student: ID!) {
    reportEdited(student: $student) {
      id
      date
      reportType
      sent
    }
  }
`;

export const ON_COMMENT_ADDED_FOR_REPORT = gql`
  subscription CommentAdded($report: ID!) {
    commentAddedForReport(report: $report) {
      user
      report
      student
      commentUser {
        sub
        name
      }
      text
      date
    }
  }
`;

export const ON_COMMENT_ADDED_FOR_STUDENT = gql`
  subscription CommentAdded($student: ID!) {
    commentAddedForStudent(student: $student) {
      user
      report
      student
      commentUser {
        sub
        name
      }
      text
      date
    }
  }
`;

export function getStudentInput(student) {
  const {
    id,
    __typename,
    reports,
    pagedReports,
    allFields,
    fields,
    parents,
    ...studentInput
  } = student;
  return Object.assign(studentInput, {
    parents: parents.map((p) => p.sub),
  });
}

export function getReportInput(report) {
  const {
    __typename,
    lastReadDate,
    log,
    comments,
    files,
    fields,
    ...reportInput
  } = report;
  return Object.assign(reportInput, {
    fields: fields.map(getFieldInput),
    files: files.map((f) => {
      const { __typename, ...file } = f;
      console.log(file);
      return file;
    }),
  });
}

export function getFieldInput(field) {
  const { __typename, ...fieldInput } = field;
  return Object.assign(fieldInput, {
    options: fieldInput.options.map((o) => {
      const { __typename, ...options } = o;
      return options;
    }),
  });
}
